module.exports = __webpack_public_path__ + "static/slide-4-60cc2b68c071b6fcb7ecdb590f42c1b1.png";